import {gsap} from 'gsap';
import Player from '@vimeo/player';

class Video {
    private video: Player;
    private readonly button: HTMLLinkElement;

    constructor(private element: HTMLElement) {
        this.button = this.element.querySelector<HTMLLinkElement>('.video-button');

        if (this.button) {
            this.init();
        }
    }

    private init() {
        this.renderVideo();
    }

    private renderVideo() {
        const start = 69; // timestamp to start showing button
        const container = this.element.querySelector<HTMLElement>('.component-video');
        const overlay = document.querySelector<HTMLElement>('.video-fullscreen-overlay');
        const url = (window as any).vimeoUrl;

        if (!url) {
            return;
        }

        this.video = new Player(container, {
            url: url
        });

        this.video.on('timeupdate', (e) => {
            const currentTime = e.seconds;

            if (currentTime >= start) {
                this.button.classList.add('active');
            } else {
                this.button.classList.remove('active');
            }
        });

        this.video.on('play', () => {
            container.classList.add('playing');

            if (window.innerWidth <= 575 || window.innerHeight <= 575) {
                this.video.requestFullscreen().then(() => {
                    this.video.on('fullscreenchange', (data) => {
                        if (!data.fullscreen) {
                            this.video.pause();
                            this.video.off('fullscreenchange');
                        }
                    });
                });
            }
        });
    }
}

window.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.video-component');

    elements?.forEach((element) => {
        new Video(element as HTMLElement);
    });
});